import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { IRoute, IRouteUpdate } from "../../../models/route";
import routeService from "../../../services/routeService/RouteService";
import RouteFormPage from "../../../components/routes/RouteFormPage";
import { Box } from "@mui/material";

const SUCCESS_STATUS_CODE = 200;

const RouteEditPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    const route = location.state as IRoute;

    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const onUpdateRoute = async (payload: IRouteUpdate) => {
        setErrorMessage(null);

        try {
            const response = await routeService.PutRoute(payload);
            if (response?.status === SUCCESS_STATUS_CODE) navigate("..");
        } catch {
            setErrorMessage(t("table.route.updateError"));
        }
    };

    return (
        <Box flex={1} height={"100%"} width={"100%"}>
            <RouteFormPage
                mode="edit"
                initialValues={{
                    ...route,
                    userIds: route.users.map((user) => user.id),
                }}
                errorMessage={errorMessage}
                onSubmit={onUpdateRoute}
                onCancel={() => navigate("..")}
            />
        </Box>
    );
};

export default RouteEditPage;